import AuthServiceRepository from "../../ports/authServiceRepository";

export type reauthenticateUserUsecase = (
  password: string,
) => Promise<void>;

export const buildReauthenticateUser = (dependencies: {
  authServiceRepo: AuthServiceRepository;
}): reauthenticateUserUsecase => {
  const { authServiceRepo } = dependencies;

  const reauthenticateUser: reauthenticateUserUsecase = async (password: string) =>
    authServiceRepo.reauthenticateUser(password);

  return reauthenticateUser;
};
